import React from 'react'
import parser from 'html-react-parser'
import CareBg from '@images/care-do-bg.jpg';

export default function MoreHighlight({ data }) {
    const { moreHighlightButtonLink, moreHighlightTitle, moreHighlightText, moreHighlightSubtitile, moreHighlightButtonText, moreHighlightButtonExternalLink } = data
    return (
        <div
            className='care-do-wrap font-white'
            style={{ background: `url(${CareBg}) left bottom no-repeat` }}
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <div className='more-outline-text-image'></div>
                        <h2 className='heading-level-1'>{moreHighlightTitle && parser(moreHighlightTitle)}</h2>
                        <div className='heading-level-4-b white-color mb-4'>
                            {moreHighlightSubtitile && parser(moreHighlightSubtitile)}
                        </div>
                        <p>{moreHighlightText && parser(moreHighlightText)}</p>
                        {moreHighlightButtonExternalLink ? (
                            <a href={moreHighlightButtonExternalLink} className="btn white-btn">
                                {moreHighlightButtonText}
                            </a>
                        ) : moreHighlightButtonLink ? (
                            <a
                                href={`mailto:${moreHighlightButtonLink}`}
                                className='btn white-btn'
                            >
                                {moreHighlightButtonText}
                            </a>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
